﻿import { inherits } from 'ol/index.js';
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import { defaults as defaultControls, Control } from 'ol/control.js';
import { defaults as defaultInteractions, Draw, Modify, Select, Snap } from 'ol/interaction.js';
import TileLayer from 'ol/layer/Tile.js';
import { get as getProjection, toLonLat } from 'ol/proj.js';
import OSM from 'ol/source/OSM.js';
import TileWMS from 'ol/source/TileWMS.js';
import TileGrid from 'ol/tilegrid/TileGrid.js';
import Projection from 'ol/proj/Projection.js';
import { register } from 'ol/proj/proj4.js';
import proj4 from 'proj4';
import { getWidth } from 'ol/extent.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import { Circle as CircleStyle, Icon, Fill, Stroke, Style, Text } from 'ol/style.js';
import { bbox } from 'ol/loadingstrategy.js';
import truncate from '@turf/truncate';
import SldStyleParser from '../Map/geostyler-sld-parser/build/dist/SldStyleParser';
import OlStyleParser from '../Map/geostyler-openlayers-parser/build/dist/OlStyleParser';

//import OLCesium from 'ol-cesium';
//import tree from 'gijgo';
import { Polygon, MultiPolygon, LineString, MultiLineString, Point, MultiPoint, GeometryCollection } from 'ol/geom.js';
import { click } from 'ol/events/condition.js';
import { WKT } from 'ol/format';
import Overlay from 'ol/Overlay.js';
import PointerEvent from 'ol/pointer/PointerEvent.js';
import MapBrowserPointerEvent from 'ol/MapBrowserPointerEvent.js';
import Collection from 'ol/Collection.js';
import toastr from 'toastr/toastr.js';
import { Sgs } from '../../../lib/sgs/sgs.js';
import { Utility } from '../../../lib/sgs/Utility.js';

import Feature from 'ol/Feature.js';

/**
 * Define a namespace for the application.
 */
window.app = {};
const app = window.app;

/********************************************************************************************
 * -------------------------------- BEGIN Interaction SELECT ------------------------------ *
 ********************************************************************************************/
app._useSelectModify = true; // TEMP

app.CreateModifyForSelect = function () {
    app.Modify = new Modify({
        features: app.Select.getFeatures()
    });
    app.Modify.setActive(true);
    app.sgs.Map.map.addInteraction(app.Modify);

    app.Modify.on('modifyend', function (e) {
        var feature = app.Select.getFeatures().getArray()[0];

        // Check if traffice tool is on and get the subroad nearest
        if( app.sgs.Map._settings._mapSettings.operation_visible.TrafficSignTool)
        {
            let layerInfo = app.sgs.Map.layerTree.layerInfo.dict_layer_info[app.sgs.Map.layerTree.selectedLayer].layer_info;
            if (layerInfo.layerName === app.sgs.Map._trafficSignTool.layerNameTrafficSign && feature)
            {
                app.sgs.Map._trafficSignTool.IdentifySubRoadNearest(feature, "edit");
            }
        }

        // Check if traffice tool is on and get the subroad nearest
        if (app.sgs.Map._settings._mapSettings.operation_visible.ManagerTrafficSignTool)
        {
            let layerInfo = app.sgs.Map.layerTree.layerInfo.dict_layer_info[app.sgs.Map.layerTree.selectedLayer].layer_info;
            //if (app.sgs.Map._managerTrafficSignTool.arrayLayerNameTrafficSign.find(c => c == layerInfo.layerName) !== undefined)
            if (layerInfo.layerName == app.sgs.Map._managerTrafficSignTool.prumoInfo.layerName && feature)
            {
                app.sgs.Map._managerTrafficSignTool.IdentifySubRoadNearest(feature, "edit");
            }
        }

        if (feature) {
            var geom = feature.getGeometry();
            var area_m2;
            var length_m;
            var area_ha;

            if (geom instanceof LineString || geom instanceof MultiLineString) {
                length_m = app.lengthFunction(geom);

                $('#offcanvas-info header')[0].innerHTML = 'Comprimento';
                $('#sgs-measure-input-m').html(length_m);
                $('#sgs-measure-input-ha').html("");

                app.OpenOffcanvasInfo();
                //$('#offcanvas-info').addClass('show');
                //if (app.sgs._utility.mobilecheck())
                //    $('#offcanvas-info').addClass('showreponsive')
                //$('#offcanvas-info').addClass('height-length');
            }
            else if (geom instanceof Point || geom instanceof MultiPoint) {

                var coordinates = geom.getCoordinates()
                if (geom instanceof MultiPoint)
                    coordinates = coordinates[0]

                $('#offcanvas-info header')[0].innerHTML = 'Coordenada';
                $('#sgs-measure-input-m').html('Coordenada X: ' + coordinates[0]);
                $('#sgs-measure-input-ha').html('Coordenada Y: ' + coordinates[1]);
                app.OpenOffcanvasInfo();
                //$('#offcanvas-info').addClass('show');
                //if (app.sgs._utility.mobilecheck())
                //    $('#offcanvas-info').addClass('showreponsive')
                //$('#offcanvas-info').removeClass('height-length');
            }
            else {
                if (geom instanceof Polygon) {
                    area_m2 = app.areaFunction(geom);
                    area_ha = Math.round(app.sgs._utility.ConvertToHa(parseFloat(area_m2)) * 100) / 100;
                }
                else if (geom instanceof MultiPolygon) {
                    area_m2 = app.areaFunction(geom);
                    area_ha = Math.round(app.sgs._utility.ConvertToHa(parseFloat(area_m2)) * 100) / 100;
                }

                var output_area_m2 = Math.round(area_m2 * 100) / 100 + ' m<sup>2</sup>';
                var output_area_ha;
                if (area_ha)
                    output_area_ha = area_ha + ' ha';

                app.OpenOffcanvasInfo();
                //$('#offcanvas-info').addClass('show');
                //if (app.sgs._utility.mobilecheck())
                //    $('#offcanvas-info').addClass('showreponsive')
                //$('#offcanvas-info').removeClass('height-length');

                $('#offcanvas-info header')[0].innerHTML = 'Área';
                $('#sgs-measure-input-m').html(output_area_m2);
                $('#sgs-measure-input-ha').html(output_area_ha);
            }
        }
    });
};

app.CreateSelect = function (layers) {
    if (app.Select) {
        app.Select.setActive(false);
        app.Select.setMap(undefined);
    }
    if (app.Modify) {
        app.Modify.setActive(false);
        app.Modify.setMap(undefined);
    }

    layers = layers && layers.length === 0 ? undefined : layers;

    const defaultStyle = new Style({
        fill: new Fill({
            color: 'rgba(100, 100, 100, .5)'
        }),
        stroke: new Stroke({
            color: 'rgba(255, 51, 0, 1)',
            width: 2
        }),
        image: new CircleStyle({
            radius: 5,
            fill: new Fill({
                color: 'rgba(5, 168, 255, 1)'
            })
        })
    });

    let style = layers && layers.length === 1
        ? defaultStyle //layers[0].getStyle()
        : defaultStyle

    app.Select = new Select({
        condition: click,
        layers: layers,
        wrapX: false,
        style: style
    });

app.Select.on('select', function (evt) {

    if (evt.selected.length !== 1) {
        if (app.Modify) {
            app.Modify.setActive(false);
            app.Modify.setMap(undefined);
        }
        return;
    }
    var geom = evt.selected[0].getGeometry();
    var area_m2;
    var length_m;
    var area_ha;
    var tooltipCoord = null;

    if (geom instanceof LineString || geom instanceof MultiLineString) {
        length_m = app.lengthFunction(geom);

        $('#offcanvas-info header')[0].innerHTML = 'Comprimento';
        $('#sgs-measure-input-m').html(length_m);
        $('#sgs-measure-input-ha').html("");

        app.OpenOffcanvasInfo();
        //$('#offcanvas-info').addClass('show');
        //if (app.sgs._utility.mobilecheck())
        //    $('#offcanvas-info').addClass('showreponsive')
        //$('#offcanvas-info').addClass('height-length');

        tooltipCoord = geom.getCoordinates()[0][Math.round(geom.getCoordinates()[0].length / 2)];
    }
    else if (geom instanceof Point || geom instanceof MultiPoint) {
        tooltipCoord = geom.getCoordinates()[0];

        var coordinates = geom.getCoordinates()
        if (geom instanceof MultiPoint)
            coordinates = coordinates[0]
        
        $('#offcanvas-info header')[0].innerHTML = 'Coordenada';
        $('#sgs-measure-input-m').html('Coordenada X: ' + coordinates[0]);
        $('#sgs-measure-input-ha').html('Coordenada Y: ' + coordinates[1]);
        app.OpenOffcanvasInfo();

        //$('#offcanvas-info').addClass('show');
        //if (app.sgs._utility.mobilecheck())
        //    $('#offcanvas-info').addClass('showreponsive')
        //$('#offcanvas-info').removeClass('height-length');
    }
    else {
        if (geom instanceof Polygon) {
            area_m2 = app.areaFunction(geom);
            area_ha = Math.round(app.sgs._utility.ConvertToHa(parseFloat(area_m2)) * 100) / 100;
        }
        else if (geom instanceof MultiPolygon) {
            area_m2 = app.areaFunction(geom);
            area_ha = Math.round(app.sgs._utility.ConvertToHa(parseFloat(area_m2)) * 100) / 100;
        }

        var output_area_m2 = Math.round(area_m2 * 100) / 100 + ' m<sup>2</sup>';
        var output_area_ha;
        if (area_ha)
            output_area_ha = area_ha + ' ha';

        app.OpenOffcanvasInfo();
        //$('#offcanvas-info').addClass('show');
        //if (app.sgs._utility.mobilecheck())
        //    $('#offcanvas-info').addClass('showreponsive')
        //$('#offcanvas-info').removeClass('height-length');

        $('#offcanvas-info header')[0].innerHTML = 'Área';
        $('#sgs-measure-input-m').html(output_area_m2);
        $('#sgs-measure-input-ha').html(output_area_ha);
    }

    // Tooltip
    //if (tooltipCoord) {
    //    var freguesia = evt.selected[0].getProperties().Freguesia;
    //    var code = evt.selected[0].getProperties().code;
    //    var html = '<div>' +
    //        '<a class="tooltip-close">x</a>' +
    //        '<div class="row">' + app.getLayerByName("GP:" + evt.selected[0].getId().split('.')[0]).getProperties().description + '</div>' +
    //        '<div class="row"><label>Freguesia:</label><span>' + freguesia + '</span></div>' +
    //        '<div class="row"><label>Codigo:</label><span>' + code + '</span></div>' +
    //        '</div>';
    //    app.identifyTooltipElement.innerHTML = html;
    //    app.identifyTooltip.setPosition(tooltipCoord);
    //    app.identifyTooltip.setVisible(true);
    //    $(app.identifyTooltipElement).removeClass('hidden');

    //    /**
    //     * Close tooltip
    //     */
    //    $('.tooltip-close').on('click', function () {
    //        $(app.identifyTooltipElement).addClass('hidden');
    //        app.identifyTooltip.setVisible(false);
    //    });
    //}
        // Active Modify
        if (app._useSelectModify)
            app.CreateModifyForSelect();
    });

    app.sgs.Map.map.addInteraction(app.Select);
};

/********************************************************************************************
 * ---------------------------------- END Interaction SELECT ------------------------------ *
 ********************************************************************************************/

/********************************************************************************************
 * -------------------------------- BEGIN Map definition ---------------------------------- *
 ********************************************************************************************/

// Create SGS
app.sgs = new Sgs(mapSettings);

// Init SGS
app.sgs.Init();

// Set select
app.CreateSelect();
app.Select.setActive(false);

//Header browser tab title
document.title = mapSettings.map_info.name;
/********************************************************************************************
 * ---------------------------------- END Map definition ---------------------------------- *
 ********************************************************************************************/

/**
 * Event click button execute search event occorrence
 */
$('#event-occorrence-search-btn').on('click', function () {

	// Show off canvas map list
	if (!$('#offcanvas-map-list').hasClass('active'))
		$('[href="#offcanvas-map-list"]').trigger('click');

	// Execute
	//app.execSearchEventOccorrence();
});

/********************************************************************************************
 * ----------------------------- BEGIN Interaction DRAW POINT ----------------------------- *
 ********************************************************************************************/
/**
 * Start Draw Point on Map
 **/
const styleDrawPoint =
    new Style({
        stroke: new Stroke({
            color: 'rgba(255, 255, 255, 0.8)',
            width: 4
        }),
        fill: new Fill({
            color: 'rgba(255, 255, 255, 0.8)'
        }),
        image: new CircleStyle({
            radius: 5,
            stroke: new Stroke({
                color: 'rgba(255, 0, 0, 1)',
                width: 2
            }),
            fill: new Fill({
                color: 'rgba(255, 255, 0, 0.5)'
            })
        })
    });
const styleDrawPointStroke = new Style({
    stroke: new Stroke({
        color: 'rgba(34, 139, 34, 0.5)',
        width: 8
    }),
    fill: new Fill({
        color: 'rgba(255, 255, 0, 0.5)'
    })
})

app.layerDrawPoint = new VectorLayer({
    source: new VectorSource({
        format: new GeoJSON()
    }),
    style: [
        styleDrawPoint
    ]
});

/**
 * Event on add feature point
 */
app.layerDrawPoint.getSource().on('addfeature', function (evt) {

    if (!app.sgs.Map.identifierActive) {

        var coordinates = evt.feature.getGeometry().getCoordinates();

        $('#offcanvas-info header')[0].innerHTML = 'Coordenada';
        $('#sgs-measure-input-m').html('Coordenada X: ' + coordinates[0][0]);
        $('#sgs-measure-input-ha').html('Coordenada Y: ' + coordinates[0][1]);
        $('#sgs-road-name').html('');
        app.OpenOffcanvasInfo();

        if(app.sgs.Map._settings._mapSettings.operation_visible.ManagerTrafficSignTool) {

        }
    }
});

app.sgs.Map.map.addLayer(app.layerDrawPoint);
app.layerDrawPoint.setZIndex(9999);

/**
 * Draw object
 **/
app.DrawPoint = new Draw({
    source: app.layerDrawPoint.getSource(),
    type: 'MultiPoint',
    style: styleDrawPoint,
    condition: function (evt) {
        return true;
    },
    finishCondition: function (evt) {
        return true;
    }
});

/**
 * Event draw end
 */
app.DrawPoint.on('drawstart', function (e) {

    app.layerDrawPoint.getSource().clear();

    // If identifier then clear all feature in point
    if (app.sgs.Map.identifierActive || app.sgs.Map.layerTree.modeCreateFeature) {
        app.layerDrawPoint.getSource().clear();
    }
    //$('#offcanvas-creation-occurrence-form').css({ 'transform': 'translate(-319px, 0px)' });
    //$('#offcanvas-creation-occurrence-form').addClass('active');
    //$('#creation-occurrence-X').val(e.target.finishCoordinate_[0]);
    //$('#creation-occurrence-Y').val(e.target.finishCoordinate_[1]);
});

app.DrawPoint.on('drawend', function (e) {
    //app.DrawPoint.setActive(false);
    if (app.sgs.Map.identifierActive) {
        // Get pixel from coordinates
        var pixel = app.sgs.Map.map.getPixelFromCoordinate(e.feature.getGeometry().getCoordinates()[0]);

        app.sgs.Map.ExecuteIdentifierPoint(pixel);
    }
});

app.DrawPoint.setActive(false);

app.sgs.Map.map.addInteraction(app.DrawPoint);

/********************************************************************************************
 * ----------------------------- END Interaction DRAW POINT ------------------------------- *
 ********************************************************************************************/



// The snap interaction must be added after the Modify and Draw interactions
// in order for its map browser event handlers to be fired first. Its handlers
// are responsible of doing the snapping.
//var snap = new Snap({
//    source: buildingSource
//});
//app.map.addInteraction(snap);

//const ol3d = new OLCesium({ map: app.map }); // map is the ol.Map instance
//ol3d.setEnabled(true);

//var selectSingleClick = new Select();
//app.map.addInteraction(selectSingleClick);

/********************************************************************************************
 * --------------------------------- BEGIN Utility function ------------------------------- *
 ********************************************************************************************/

/**
 * Area function
 * @param {any} geom - Geometry
 * @returns {number} area
 */
app.areaFunction = function (geom) {
    var geos = [];
    //if (geom instanceof GeometryCollection) {
    //    for (var g in geom.getGeometries())
    //        geos.push(geom.getGeometries()[g]);
    //} else
    geos = [geom];
    var a = 0;
    for (var i in geos)
        a += geos[i].getArea();
    return a;
};

/**
 * Length function
 * @param {any} geom - geometry
 * @returns {number} length
 */
app.lengthFunction = function (geom) {
    var geos = [];
    //if (geom instanceof GeometryCollection) {
    //    for (var g in geom.getGeometries())
    //        geos.push(geom.getGeometries()[g]);
    //} else
    geos = [geom];
    var l = 0;
    for (var g in geos)
        if (geom instanceof MultiLineString) {
            for (var i = 0; i < geos[g].getLineStrings().length; i++) {
                l += geos[g].getLineStrings()[i].getLength();
            }
        }
        else
            l += geos[g].getLength();
    var output = Math.round(l * 100) / 100 + " m";
    return output;
};

/********************************************************************************************
 * ----------------------------------- END Utility function ------------------------------- *
 ********************************************************************************************/

/********************************************************************************************
 * ----------------------------- BEGIN Interaction DRAW LINE ------------------------------ *
 ********************************************************************************************/
const styleDrawLine = [
    new Style({
        stroke: new Stroke({
            color: 'rgba(255, 255, 255, 0.8)',
            width: 4
        })
    }),
    new Style({
        fill: new Fill({
            color: 'rgba(255, 255, 255, 0.8)'
        }),
        stroke: new Stroke({
            color: 'rgba(0, 0, 0, 0.8)',
            lineDash: [10, 10],
            width: 2
        }),
        image: new CircleStyle({
            radius: 5,
            stroke: new Stroke({
                color: 'rgba(0, 0, 0, 0.7)'
            }),
            fill: new Fill({
                color: 'rgba(255, 255, 255, 0.2)'
            })
        })
    })
];

app.layerDrawLine = new VectorLayer({
    source: new VectorSource({
        format: new GeoJSON()
    }),
    style: styleDrawLine,
    name: 'current_draw_line'
});

app.sgs.Map.map.addLayer(app.layerDrawLine);
app.layerDrawLine.setZIndex(9999);

app.layerDrawLine.getSource().on('addfeature', function (evt) {

    var geom = evt.feature.getGeometry();
    var length_m;

    if (geom instanceof LineString || geom instanceof MultiLineString) {
        length_m = app.lengthFunction(geom);

        $('#offcanvas-info header')[0].innerHTML = 'Comprimento';
        $('#sgs-measure-input-m').html(length_m);
        $('#sgs-measure-input-ha').html("");

        app.OpenOffcanvasInfo();
        //$('#offcanvas-info').addClass('show');
        //if (app.sgs._utility.mobilecheck())
        //    $('#offcanvas-info').addClass('showreponsive')
        //$('#offcanvas-info').addClass('height-length');

    }
});

/**
 * Draw object
 **/
app.DrawLine = new Draw({
    source: app.layerDrawLine.getSource(),
    type: 'LineString',
    style: styleDrawLine,
    condition: function (evt) {

        return true;
    },
    finishCondition: function (evt) {

        return true;
    }
});

/**
 * Event draw end
 */
app.DrawLine.on('drawstart', function (evt) {
    app.layerDrawLine.getSource().clear();
    var geom = evt.feature.getGeometry();
    $('#offcanvas-info header')[0].innerHTML = 'Comprimento';
    app.OpenOffcanvasInfo();
    //$('#offcanvas-info').addClass('show');
    //if (app.sgs._utility.mobilecheck())
    //    $('#offcanvas-info').addClass('showreponsive')
    //$('#offcanvas-info').addClass('height-length');

    var lst = geom.on('change', function (e) {
        var geomE = e.target;
        var tooltipCoord = e.target.getCoordinates()[e.target.getCoordinates().length - 1];
        var length_m = app.lengthFunction(geomE);
        app.measureTooltipElement.innerHTML = length_m;
        app.measureTooltip.setPosition(tooltipCoord);
        app.measureTooltip.setVisible(true);
        $(app.measureTooltipElement).removeClass('hidden');

        $('#sgs-measure-input-m').html(length_m);
        $('#sgs-measure-input-ha').html("");
    });
});

/**
 * Event draw end
 */
app.DrawLine.on('drawend', function (evt) {
});

app.DrawLine.setActive(false);

app.sgs.Map.map.addInteraction(app.DrawLine);

/********************************************************************************************
 * --------------------------------- BEGIN Tooltip Measure -------------------------------- *
 ********************************************************************************************/
app.measureTooltipElement = null;
app.measureTooltip = null;

const createMeasureTooltip = function () {
    if (app.measureTooltipElement) {
        app.measureTooltipElement.parentNode.removeChild(app.measureTooltipElement);
    }
    app.measureTooltipElement = document.createElement('div');
    app.measureTooltipElement.className = 'tooltip tooltip-measure';
    app.measureTooltip = new Overlay({
        element: app.measureTooltipElement,
        offset: [0, -15],
        positioning: 'bottom-center',
        id: 0
    });

    app.sgs.Map.map.addOverlay(app.measureTooltip);
};

createMeasureTooltip();

/********************************************************************************************
 * ----------------------------------- END Tooltip Measure -------------------------------- *
 ********************************************************************************************/

/********************************************************************************************
 * -------------------------------- BEGIN Tooltip Identify -------------------------------- *
 ********************************************************************************************/
app.identifyTooltipElement = null;
app.identifyTooltip = null;

const createIdentifyTooltip = function () {
    if (app.identifyTooltipElement) {
        app.identifyTooltipElement.parentNode.removeChild(app.identifyTooltipElement);
    }
    app.identifyTooltipElement = document.createElement('div');
    app.identifyTooltipElement.className = 'tooltip tooltip-measure info';
    app.identifyTooltip = new Overlay({
        element: app.identifyTooltipElement,
        offset: [0, -15],
        positioning: 'bottom-center',
        id: 0
    });

    app.sgs.Map.map.addOverlay(app.identifyTooltip);
};

createIdentifyTooltip();

/********************************************************************************************
 * ----------------------------------- END Tooltip Identify ------------------------------- *
 ********************************************************************************************/

/********************************************************************************************
 * -------------------------------- BEGIN Interaction DRAW -------------------------------- *
 ********************************************************************************************/
const styleDraw = new Style({
    fill: new Fill({
        color: 'rgba(35, 181, 119, .5)'
    }),
    stroke: new Stroke({
        color: 'rgba(35, 181, 119, 1)',
        width: 2
    })
});
const styleDraw2 = new Style({

    stroke: new Stroke({
        color: 'rgba(255, 255, 255, 1)',
        width: 4
    })
});

app.layerDraw = new VectorLayer({
    source: new VectorSource({
        format: new GeoJSON()
    }),
    style: [
        styleDraw2,
        styleDraw
    ],
    name: 'current_draw'
});


app.sgs.Map.map.addLayer(app.layerDraw);
app.layerDraw.setZIndex(100000);

app.layerDraw.getSource().on('addfeature', function (evt) {

    var geom = evt.feature.getGeometry();
    var area_m2;
    var area_m;
    var area_ha;

    if (geom instanceof Polygon) {
        area_m2 = app.areaFunction(geom);
        area_ha = Math.round(app.sgs._utility.ConvertToHa(parseFloat(area_m2)) * 100) / 100;
    }
    else if (geom instanceof MultiPolygon) {
        area_m2 = app.areaFunction(geom);
        area_ha = Math.round(app.sgs._utility.ConvertToHa(parseFloat(area_m2)) * 100) / 100;
    }

    var output_area_m2 = Math.round(area_m2 * 100) / 100 + ' m<sup>2</sup>';
    var output_area_ha;
    if (area_ha)
        output_area_ha = area_ha + ' ha';

    $('#offcanvas-info header')[0].innerHTML = 'Área';
    app.OpenOffcanvasInfo();
    //$('#offcanvas-info').addClass('show');
    //if (app.sgs._utility.mobilecheck())
    //    $('#offcanvas-info').addClass('showreponsive')
    //$('#offcanvas-info').removeClass('height-length');

    $('#sgs-measure-input-m').html(output_area_m2);
    $('#sgs-measure-input-ha').html(output_area_ha);

});

/**
 * Draw object
 **/
app.Draw = new Draw({
    source: app.layerDraw.getSource(),
    type: 'Polygon',
    style: new Style({
        fill: new Fill({
            color: 'rgba(135, 144, 150, .5)'
        }),
        stroke: new Stroke({
            color: 'rgba(5, 168, 255, 1)',
            width: 1
        }),
        image: new CircleStyle({
            radius: 2,
            fill: new Fill({
                color: 'rgba(5, 168, 255, 1)'
            })
        })
    }),
    condition: function (evt) {

        return true;
    },
    finishCondition: function (evt) {

        return true;
    }
});


//app.Draw.on('drawstart', function (evt) {
//    $('#offcanvas-info header')[0].innerHTML = 'Área';
//    $('#offcanvas-info').addClass('show');

//    var geome = evt.feature.getGeometry();

//    var lst = geome.on('change', function (e) {
//        var area_m2;
//        var area_ha;
//        var geom = e.target.getGeometry();

//        if (geom instanceof Polygon) {
//            area_m2 = app.areaFunction(geom);
//            area_ha = Math.round(app.ConvertToHa(parseFloat(area_m2)) * 100) / 100;
//        } else if (geom instanceof LineString || geom instanceof MultiLineString) {
//            area_m2 = lengthFunction(geom);
//        }
//        else if (geom instanceof MultiPolygon) {
//            area_m2 = app.areaFunction(geom);
//            area_ha = Math.round(app.ConvertToHa(parseFloat(area_m2)) * 100) / 100;
//        }

//        var output_area_m2 = Math.round(area_m2 * 100) / 100 + ' m<sup>2</sup>';
//        var output_area_ha;
//        if (area_ha)
//            output_area_ha = area_ha + ' ha';

//        $('#sgs-measure-input-m').html(output_area_m2);
//        $('#sgs-measure-input-ha').html(output_area_ha);
//    });
//});

/**
 * Event draw end
 */
app.Draw.on('drawend', function (evt) {
    app.layerDraw.getSource().clear();
});

app.Draw.setActive(false);

app.sgs.Map.map.addInteraction(app.Draw);

/********************************************************************************************
 * ---------------------------------- END Interaction DRAW -------------------------------- *
 ********************************************************************************************/

/********************************************************************************************
 * -------------------------------- BEGIN Interaction MODIFY ------------------------------ *
 ********************************************************************************************/

//app.ModifySelect = new Modify({
//    features: app.Select.getFeatures()
//});
//app.map.addInteraction(app.ModifySelec);

/********************************************************************************************
 * ---------------------------------- END Interaction MODIFY ------------------------------ *
 ********************************************************************************************/

/********************************************************************************************
 * ------------------------------------ BEGIN Highlight ----------------------------------- *
 ********************************************************************************************/

// Default highligh style
app.defaultHighlighStyles = [
    new Style({
        image: new CircleStyle({
            radius: 4,
            stroke: new Stroke({
                color: 'orange',
                width: 3
            }),
            fill: new Fill({
                color: 'rgba(255, 255, 0, 0.5)'
            })
        }),
        stroke: new Stroke({
            color: 'orange',
            width: 3
        }),
        fill: new Fill({
            color: 'rgba(255, 255, 0, 0.5)'
        })
    })
];

app.featureToHighLight = new Collection();

app.featureHighlightOverlay = new VectorLayer({
    source: new VectorSource({ features: app.featureToHighLight, useSpatialIndex: true }),
    style: new Style({
        fill: new Fill({
            color: 'rgba(255, 255, 255, 0.2)'
        }),
        stroke: new Stroke({
            color: '#00FFFF', //'#ffcc33',
            width: 2
        }),
        image: new CircleStyle({
            radius: 7,
            fill: new Fill({
                color: '#00FFFF'//, //'#ffcc33'
            })
        })
    }),
    id: 'HighlightFeatures'
});
app.featureHighlightOverlay.setMap(app.sgs.Map.map);

app.setFeaturesHighlightByArray = function (workspace, layerName, idsArray, typeElement) {
    // Array to string
    var idsString = idsArray.toString();

    var getFeatureUrl = "/geoserver/1" + "/wfs";

    // Call geoserver to get the feature of the layer
    var getFeature = $.ajax({
        method: "GET",
        async: false,
        url: getFeatureUrl,
        data: {
            "service": 'wfs',
            "version": '2.0.0',
            "request": 'GetFeature',
            "typeNames": workspace + ':' + layerName,
            "featureID": idsString,
            "propertyName": 'geom',
            "outputFormat": 'application/json'
        }
    });

    // Response from the server
    getFeature.done(function (data, textStatus, jqXHR) {
        if (data.features) {
            if (data.features.length > 0) {
                for (var i = 0; i < data.features.length; i++) {
                    app.featureToHighLight.push((new GeoJSON()).readFeatures(data)[i]);
                    var styleElement = null;
                    //var typeGeom = app.featureToHighLight.getArray()[app.featureToHighLight.getArray().length - 1].getGeometry().getType();
                    switch (typeElement) {
                        case "ws_pipes":
                            styleElement = [
                                new Style({
                                    image: new CircleStyle({
                                        radius: 4,
                                        stroke: new Stroke({
                                            color: 'red',
                                            width: 2
                                        }),
                                        fill: new Fill({
                                            color: 'rgba(255, 255, 0, 1)'
                                        })
                                    }),
                                    stroke: new Stroke({
                                        color: 'red',
                                        width: 3
                                    }),
                                    fill: new Fill({
                                        color: 'rgba(255, 255, 0, 0.5)'
                                    })
                                    ,
                                    text: new Text({
                                        text: '',
                                        font: 'normal 14px Arial',
                                        textBaseline: 'Middle',
                                        offsetY: -10,
                                        backgroundFill: new Fill({ color: 'white' }),
                                        fill: new Fill({
                                            color: 'rgba(0, 0, 0, 1)'
                                        }),
                                        stroke: new Stroke({
                                            color: 'rgba(255, 255, 200, 1)',
                                            width: 8
                                        })
                                    })
                                })
                            ];
                            break;
                        case "ws_isolation_valve":
                            styleElement = [
                                new Style({
                                    image: new CircleStyle({
                                        radius: 4,
                                        stroke: new Stroke({
                                            color: 'red',
                                            width: 2
                                        }),
                                        fill: new Fill({
                                            color: 'rgba(255, 255, 0, 1)'
                                        })
                                    }),
                                    stroke: new Stroke({
                                        color: 'red',
                                        width: 3
                                    }),
                                    fill: new Fill({
                                        color: 'rgba(255, 255, 0, 0.5)'
                                    })
                                })
                            ];
                            break;
                        case "ws_water_origin":
                            styleElement = [
                                new Style({
                                    image: new CircleStyle({
                                        radius: 4,
                                        stroke: new Stroke({
                                            color: 'blue',
                                            width: 2
                                        }),
                                        fill: new Fill({
                                            color: 'rgba(0, 0, 255, 1)'
                                        })
                                    }),
                                    stroke: new Stroke({
                                        color: 'blue',
                                        width: 3
                                    }),
                                    fill: new Fill({
                                        color: 'rgba(0, 0, 255, 0.5)'
                                    })
                                })
                            ];
                            break;
                        case "trecho":
                        case "malha":
                        case "evento":
                            styleElement = [
                                new Style({
                                    image: new CircleStyle({
                                        radius: 10,
                                        stroke: new Stroke({
                                            color: '#ffff00',
                                            width: 5
                                        }),
                                        fill: new Fill({
                                            color: 'rgba(0, 0, 255, 0.2)'
                                        })
                                    }),
                                    stroke: new Stroke({
                                        color: '#ffff00',
                                        width: 14
                                    }),
                                    fill: new Fill({
                                        color: 'rgba(0, 0, 255, 0.5)'
                                    })
                                })
                            ];
                            break;
                        default:
                            styleElement = app.defaultHighlighStyles;
                    }
                    app.featureToHighLight.getArray()[app.featureToHighLight.getArray().length - 1].setStyle(styleElement);
                }
                // Go to Feature
                app.sgs.Map.map.getView().fit(app.featureHighlightOverlay.getSource().getExtent(), { size: app.sgs.Map.map.getSize() });
            }
        }
    });
};


/********************************************************************************************
 * --------------------------------------- END MOVE TO OCCURRENCE ------------------------- *
 ********************************************************************************************/

/********************************************************************************************
 * ----------------------------- BEGIN Interaction DRAW POINT POI SHORTCUT ---------------- *
 ********************************************************************************************/
/**
 * Start Draw Point on Map
 **/
const styleDrawPointPOI = new Style({
    text: new Text({
        text: '\uf041', //map-marker
        font: 'normal 22px FontAwesome',
        textBaseline: 'bottom',
        fill: new Fill({
            color: 'red',
        })
    })
});

app.layerDrawPointPOI = new VectorLayer({
    source: new VectorSource({
        format: new GeoJSON()
    }),
    style: [
        styleDrawPointPOI
    ]
});

app.sgs.Map.map.addLayer(app.layerDrawPointPOI);

/**
 * Draw object
 **/
app.DrawPointPOI = new Draw({
    source: app.layerDrawPointPOI.getSource(),
    type: 'Point',
    style: styleDrawPointPOI,
    condition: function (evt) {
        return true;
    },
    finishCondition: function (evt) {
        return true;
    }
});

/**
 * Event draw end
 */
app.DrawPointPOI.on('drawstart', function (e) {
    $('#modal-x_center').val(e.target.finishCoordinate_[0]);
    $('#modal-y_center').val(e.target.finishCoordinate_[1]);
    // show modal window
    
    $('#modal-shortcut').css({ 'display': 'block' });
    //app.sgs.Map.map.addLayer(app.layerDrawPointPOI);
});

app.DrawPointPOI.on('drawend', function (e) {
    app.DrawPointPOI.setActive(false);
});

app.DrawPointPOI.setActive(false);

app.sgs.Map.map.addInteraction(app.DrawPointPOI);

/********************************************************************************************
 * ----------------------------- END Interaction DRAW POINT POI SHORTCUT ------------------ *
 ********************************************************************************************/


/********************************************************************************************
 * -------------------------------- BEGIN DRAW POINT POI SHORTCUT ------------------------- *
 ********************************************************************************************/
/**
 * Start Draw Point on Map
 **/


var marker = new Feature({
    geometry: new Point([0, 0])
});

app.layerDrawPointPOIShow = new VectorLayer({
    source: new VectorSource({
        features:[marker]
    }),
    style: [
        styleDrawPointPOI
    ]
});

app.sgs.Map.map.addLayer(app.layerDrawPointPOIShow);
app.layerDrawPointPOIShow.getSource().clear();

app.DrawPointPOIShow = new Draw({
    source: app.layerDrawPointPOIShow.getSource(),
    type: 'Point',
    style: styleDrawPointPOI
});

/********************************************************************************************
 * ----------------------------- END DRAW POINT POI SHORTCUT ------------------------------ *
 ********************************************************************************************/

/**
 * Open canvas info
 */
app.OpenOffcanvasInfo = function () {
    var rightValue = 0;
    if ($('#offcanvas-info').hasClass("offcanvas-no-control-bar"))
        rightValue = 60;
    $('#offcanvas-info').addClass('show');
    if ($('.offcanvas-pane.active').length > 0) {
        $('#offcanvas-info').css('right', ($('.offcanvas-pane.active').width() + 50 + rightValue) + "px");
    }
    else {
        $('#offcanvas-info').css('right', (50 + rightValue) + "px");
    }
    if (app.sgs._utility.mobilecheck())
        $('#offcanvas-info').addClass('showreponsive')
    $('#offcanvas-info').removeClass('height-length');
}